import React from "react";
import { compose } from "redux";
import withToggleAlert from "../../../../../../hocs/withToggleAlert";
import withUserData from "../../../../../../hocs/withUserData";
import withStockIsFollowed from "../../../../../../hocs/withStockIsFollowed";
import withTranslations from "../../../../../../hocs/withTranslations";
import bellIcon from "./assets/bell.svg";
import yellowBellIcon from "./assets/yellow-bell.svg";
import classNames from "classnames";
import useIsDesktop from "../../../../landingPage/hooks/useIsDesktop";

const StockAlertButton = ({
  stockIsFollowed: alerted,
  toggleAlert,
  stockId,
  ticker,
  market,
  translate
}) => {
  const isDesktop = useIsDesktop();
  const commonButtonClasses =
    "flex align-center bg-gray-5 border-none rounded-1 hover:bg-gray-6 focus:bg-gray-6";
  const icon = alerted ? yellowBellIcon : bellIcon;

  if (!isDesktop) {
    return (
      <button
        className={classNames(commonButtonClasses, "rounded-full p-2.5")}
        onClick={() => {
          toggleAlert({ stockId, ticker, market });
        }}
      >
        <img
          src={icon}
          alt="bell"
          width={20}
          height={20}
          className={"shrink-0"}
        />
      </button>
    );
  }

  return (
    <button
      className={classNames(commonButtonClasses, "gap-3 py-2 px-2.5 rounded-1")}
      onClick={() => {
        toggleAlert({ stockId, ticker, market });
      }}
    >
      <img
        src={icon}
        alt="bell"
        width={24}
        height={24}
        className={"shrink-0"}
      />
      <span
        className={classNames(
          "text-sm font-semibold line-height-100 text-black",
          { "opacity-75": !alerted }
        )}
      >
        {alerted ? translate("Turn off alert") : translate("Turn on alert")}
      </span>
    </button>
  );
};

export default compose(
  withTranslations,
  withToggleAlert,
  withUserData,
  withStockIsFollowed(props => props.stockId)
)(StockAlertButton);
